export default "__VITE_ASSET__KvavlU7d__"